import $ from 'jquery';

const STICKY_PAGES = ['/', '/clients', '/crew'];

const StickyHeader = () => {
	const isAllowedPage = () => {
		const path = window.location.pathname.replace(/\/$/, '') || '/';
		return STICKY_PAGES.includes(path);
	};

	const init = () => {
		const header = $('#hide-header');
		const headerWhite = $('#hide-header-white');
		// if (!header.length) return;

		if (!isAllowedPage()) {
			header.addClass('header-visible');
			headerWhite.addClass('header-visible');
			return;
		}

		$(window).on('scroll.stickyHeader', function () {
			const currentScrollPos = $(window).scrollTop();

			if (currentScrollPos <= 0) {
				header.removeClass('header-visible');

				headerWhite.removeClass('header-visible');
			} else {
				header.addClass('header-visible');

				headerWhite.addClass('header-visible');
			}
		});
	};

	const initElementor = () => {
		if (window.elementorFrontend?.hooks) {
			window.elementorFrontend.hooks.addAction(
				'frontend/element_ready/global',
				() => init(),
			);
		}
	};

	const boot = () => {
		init();
		initElementor();
	};

	boot();
};

try {
	$(function () {
		StickyHeader();
	});
} catch (error) {
	console.error('StickyHeader error:', error);
}
